export const APARTMENT_EVENING_COLOUR = 'apartmentExterior'
export const APARTMENT_NIGHT_COLOUR = 'apartmentNight'
export const BANCROFT_EXTERIOR_COLOUR = 'bancroftExterior'
export const BANCROFT_GATE_COLOUR = 'bancroftGate'
export const BASEMENT_CEILING_COLOUR = 'basementCeiling'
export const BENNETT_BED_COLOUR = 'bennettBed'
export const BENNETT_BED_DIM_COLOUR = 'bennettBedDim'
export const BENNETT_CARPET_COLOUR = 'bennettCarpet'
export const BENNETT_CARPET_DIM_COLOUR = 'bennettCarpetDim'
export const BENNETT_COUCH_COLOUR = 'bennettCouch'
export const BENNETT_FLOOR_COLOUR = 'bennettFloor'
export const BENNETT_WALL_COLOUR = 'bennettWall'
export const BENNETT_WALL_DIM_COLOUR = 'bennettWallDim'
export const CINEMA_EXTERIOR_COLOUR = 'cinemaExterior'
export const CLUB_FRONT_PRIMARY_COLOUR = 'clubFrontPrimary'
export const CLUB_FRONT_SECONDARY_COLOUR = 'clubFrontSecondary'
export const CLUB_SIDE_PRIMARY_COLOUR = 'clubSidePrimary'
export const CLUB_SIDE_SECONDARY_COLOUR = 'clubSideSecondary'
export const CONCRETE_PLATFORM_COLOUR = 'concrete'
export const CONCRETE_PLATFORM_EVENING_COLOUR = 'concreteEvening'
export const CONCRETE_PLATFORM_NIGHT_COLOUR = 'concreteNight'
export const CROSSWALK_COLOUR = 'crosswalk'
export const CROSSWALK_NIGHT_COLOUR = 'crosswalkNight'
export const DARK_ROOM_COLOUR = 'darkRoom'
export const DEATHBED_FLOOR_COLOUR = 'deathbedFloor'
export const DEFAULT_CLEAR_COLOUR = 'clear'
export const DIRT_FLOOR_COLOUR = 'dirtFloor'
export const FAMILY_EXTERIOR_COLOUR = 'familyExterior'
export const FANCY_WALL_COLOUR = 'fancyWall'
export const FURNITURE_PLATFORM_COLOUR = 'lizNightstand'
export const FUTURE_PLATFORM_COLOUR = 'futurePlatform'
export const FUTURE_SPOTLIGHT_LIGHT_COLOUR = 'futureSpotlightLight'
export const FUTURE_SPOTLIGHT_LIGHTER_COLOUR = 'futureSpotlightLighter'
export const FUTURE_SPOTLIGHT_LIGHTEST_COLOUR = 'futureSpotlightLightest'
export const FUTURE_SPOTLIGHT_MEDIUM_COLOUR = 'futureSpotlightMedium'
export const GENERIC_EXTERIOR_COLOUR = 'genericExterior'
export const GENERIC_EVENING_COLOUR = 'genericEvening'
export const GENERIC_NIGHT_COLOUR = 'genericNight'
export const GRASS_AUTUMN_COLOUR = 'grassAutumn'
export const GRASS_AUTUMN_EVENING_COLOUR = 'grassAutumnEvening'
export const GRASS_AUTUMN_NIGHT_COLOUR = 'grassAutumnNight'
export const GRASS_COLOUR = 'grass'
export const GRASS_EVENING_COLOUR = 'grassEvening'
export const GRASS_NIGHT_COLOUR = 'grassNight'
export const GRASS_WINTER_EVENING_COLOUR = 'grassWinter'
export const GROUND_CLEAR_COLOUR = 'ground'
export const INDUSTRIAL_WALL_COLOUR = 'industrialWall'
export const LINOLEUM_FLOOR_COLOUR = 'linoleumFloor'
export const LINOLEUM_PAST_COLOUR = 'linoleumPast'
export const LIZ_BED_COLOUR = 'lizBed'
export const LIZ_COUCH_COLOUR = 'lizCouch'
export const LIZ_EVENING_COLOR = 'lizExterior'
export const LIZ_FLOOR_COLOUR = 'lizFloor'
export const LIZ_GATE_COLOUR = 'lizGate'
export const LIZ_GATE_EVENING_COLOUR = 'lizGateEvening'
export const LIZ_GATE_NIGHT_COLOUR = 'lizGateNight'
export const LIZ_WALL_COLOUR = 'lizWall'
export const MAGIC_COLOUR = 'magic'
export const MIRIAM_COUCH_COLOUR = 'miriamCouch'
export const NIGHT_FUTURE_COLOUR = 'nightFuture'
export const OCEAN_NIGHT_COLOUR = 'ocean'
export const OLD_FLOOR_COLOUR = 'oldFloor'
export const PAST_PLATFORM_COLOUR = 'pastPlatform'
export const PAVEMENT_COLOUR = 'pavement'
export const PAVEMENT_EVENING_COLOUR = 'pavementEvening'
export const PAVEMENT_NIGHT_COLOUR = 'pavementNight'
export const PLATFORM_COLOUR = 'platform'
export const PLATFORM_EVENING_COLOUR = 'platformEvening'
export const PRESENT_PLATFORM_COLOUR = 'presentPlatform'
export const ROOF_COLOUR = 'roof'
export const ROOF_EVENING_COLOUR = 'roofEvening'
export const ROOF_NIGHT_COLOUR = 'roofNight'
export const SAND_NIGHT_COLOUR = 'sand'
export const SCHOOL_FLOOR_COLOUR = 'schoolFloor'
export const SCHOOL_WALL_COLOUR = 'schoolWall'
export const SNOW_FLOOR_COLOUR = 'snowFloor'
export const SOFT_WALL_COLOUR = 'softWall'
export const SPOTLIGHT_LIGHT_COLOUR = 'spotlightLight'
export const SPOTLIGHT_LIGHTER_COLOUR = 'spotlightLighter'
export const SPOTLIGHT_LIGHTEST_COLOUR = 'spotlightLightest'
export const SPOTLIGHT_MEDIUM_COLOUR = 'spotlightMedium'
export const STREET_COLOUR = 'street'
export const STREET_EVENING_COLOUR = 'streetEvening'
export const STREET_NIGHT_COLOUR = 'streetNight'
export const TAIWAN_GATE_NIGHT_COLOUR = 'taiwanGate'
export const TAIWAN_WALL_NIGHT_COLOUR = 'taiwanWall'
export const TENNIS_COLOUR = 'tennis'
export const UNDERGROUND_WALL_COLOUR = 'basementWall'
export const VAN_NUYS_EXTERIOR_COLOUR = 'vanNuysExterior'
export const VELVET_FLOOR_COLOUR = 'velvetFloor'
export const WAITING_ARMCHAIR_COLOUR = 'waitingArmchair'
export const WOOD_FLOOR_COLOUR = 'woodFloor'
